<template lang="pug">
.fail-network
  img.pic(:src="errorPage")
  .tip {{ errorTip }}
</template>
<script>
import { env } from '@hb/hbridge';
import CommonHeader from '@/components/common-header';

export default {
  components: {
    CommonHeader,
  },
  props: {
    errorPage: {
      type: String,
      default:
        'https://m.hellobike.com/resource/gallery/407/iUOp9M3ZoI.png?x-oss-process=image/quality,q_80',
    },
    errorTip: {
      type: String,
      default: '请稍后重试',
    },
  },
  data() {
    return {
      isEasyBikeApp: env.isEasyBikeApp,
    };
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
  },
};
</script>
<style lang="less" scoped>
.fail-network {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  flex-direction: column;

  .pic {
    height: 1rem;
  }

  .tip {
    margin-top: 0.16rem;
    font-size: 0.14rem;
    font-weight: 400;
    color: #242729;
  }
}
</style>
